import sliceCreator from '../../index.jsx';
import {CREATE_DAILY_TASK} from '../../../constants/index.jsx';
const _createDailyTaskAction = sliceCreator('CREATE_DAILY_TASK', CREATE_DAILY_TASK, 'post');

const { asyncAction: createDailyTaskAction, reducer, clearData: clearCreateDailyTaskAction } = _createDailyTaskAction;

export default reducer;

export {
    createDailyTaskAction,
    clearCreateDailyTaskAction
}